import React from 'react';

const Svg = (props) => (
  <svg {...props} viewBox="0 0 20 20"><path data-follow-fill="currentColor" d="M13.733 12.433v-.05c-.258-3.233-2.883-5.858-6.142-6.116h-.025a5.412 5.412 0 0 1 5.35-4.6 5.417 5.417 0 0 1 5.417 5.416c0 2.717-2 4.959-4.6 5.35Z" fill="currentColor"/><path fill-rule="evenodd" clip-rule="evenodd" d="M7.517 7.517a5.417 5.417 0 1 0-.867 10.8 5.417 5.417 0 0 0 .867-10.8ZM7.084 15l-.734-1.35L5 12.917l1.35-.734.734-1.35.733 1.35 1.35.734-1.35.733L7.084 15Z" data-follow-fill="currentColor" fill="currentColor"></path></svg>
);

export default Svg;
